import React, { createContext, useEffect } from "react";
import "./ChemPesticidesTableRow.css";
import { Form } from "antd";

export const FormContext = createContext(null);

function ChemPesticidesTableRow({
  record, index, saveFormInstance, ...antdProps
}) {
  const [form] = Form.useForm();
  // Store the current form to the ChemPesticidesModal component
  useEffect(() => {
    if (saveFormInstance) {
      saveFormInstance(form, index);
    }
  }, [form, index, saveFormInstance]);
  return (
    <Form form={form} component={false} preserve={false}>
      <FormContext.Provider value={form}>
        <tr
          {...antdProps} // eslint-disable-line react/jsx-props-no-spreading
          className={`${antdProps.className} ChemPesticidesTableRow`}
        />
      </FormContext.Provider>
    </Form>

  );
}

export default ChemPesticidesTableRow;
